import GetMembershipDocumentsRequestModelBase from '../_generated/modelBases/get-membership-documents-request-model-base';

export default class GetMembershipDocumentsRequestModel extends GetMembershipDocumentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
